class OurImpactInNumbers extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.our-impact-in-numbers__swiper');
    this.swiper = null;
    this.onBlockSelect = this.onBlockSelect.bind(this);
  }

  connectedCallback() {
    if (!this.swiperEl || typeof Swiper === 'undefined') return;

    const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10);

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 1.14159,
      centeredSlides: true,
      speed: 1500,
      autoplay: autoplayDelay > 0 && { delay: autoplayDelay, disableOnInteraction: false },
      spaceBetween: 12,
      initialSlide: 2,
      loop: true,
      watchOverflow: true,
      breakpoints: {
        768: { slidesPerView: 1.5, centeredSlides: true },
        990: { slidesPerView: 2, centeredSlides: false },
        1200: { slidesPerView: 3, centeredSlides: false },
      },
      navigation: {
        nextEl: this.querySelector('.our-impact-in-numbers__arrow--next'),
        prevEl: this.querySelector('.our-impact-in-numbers__arrow--prev'),
      },
    });

    this.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onBlockSelect(event) {
    if (!this.swiper) return;
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    this.swiper.slideTo(Array.from(this.swiper.slides).indexOf(slide));
  }
}

if (!customElements.get('our-impact-in-numbers')) {
  customElements.define('our-impact-in-numbers', OurImpactInNumbers);
}
